export const grHeaderShimmerEffect = () => {
    const grHeaderShimmer = document?.querySelector('.cca-header-shimmer');
    if (grHeaderShimmer) {
        grHeaderShimmer.style.display = 'none';
    }
};

export const grSectionShimmerEffect = () => {
    const grSection = document.querySelector('.guidedForm_shimmer__section');
    if (grSection) {
        grSection.style.display = 'none';
    }
};

export const grPersonalInfoShimmerEffect = () => {
    const grPersonalInfoSection = document.querySelector('.stepform_shimmer__section');
    if (grPersonalInfoSection) {
        grPersonalInfoSection.style.display = 'none';
    }
};

export const applicationErrorShimmerEffect = () => {
    const applicationErrorScreen = document.querySelector('.loading-shimmer');
    if (applicationErrorScreen) {
        applicationErrorScreen.style.display = 'none';
    }
};
